import Swiper, { Navigation, Pagination, Thumbs } from "swiper";

// Idempotent: bails if no PDP markers; flags initialised elements so
// re-invocation (it's also called from common.js) doesn't double-bind.
export default {
  init() {
    if (document.body.dataset.pdpInited === "1") return;
    const hasPdp = document.querySelector(
      ".product-gallery-swiper, .pdp-qty, .pdp-tabs, .pdp-spec-content, .pdp-description-content"
    );
    if (!hasPdp) return;
    document.body.dataset.pdpInited = "1";

    // ── Product gallery with thumbnail strip ──────────────────────────
    const mainGalleryEl  = document.querySelector(".product-gallery-swiper");
    const thumbsGalleryEl = document.querySelector(".product-gallery-thumbs");

    if (mainGalleryEl && thumbsGalleryEl) {
      const thumbsSwiper = new Swiper(".product-gallery-thumbs", {
        slidesPerView: "auto",
        spaceBetween: 8,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
      });

      new Swiper(".product-gallery-swiper", {
        modules: [Navigation, Pagination, Thumbs],
        spaceBetween: 0,
        navigation: {
          nextEl: ".product-gallery-next",
          prevEl: ".product-gallery-prev",
        },
        pagination: {
          el: ".product-gallery-pagination",
          clickable: true,
        },
        thumbs: {
          swiper: thumbsSwiper,
        },
      });
    }

    // ── PDP qty stepper (+ / −) ───────────────────────────────────────
    const qtyEl = document.querySelector(".pdp-qty");
    if (qtyEl) {
      const input = qtyEl.querySelector(".pdp-qty__input");
      const decr  = qtyEl.querySelector(".js-pdp-qty-decr");
      const incr  = qtyEl.querySelector(".js-pdp-qty-incr");

      const clamp = (v) => {
        const min = parseInt(input.min || "1", 10);
        const max = input.max ? parseInt(input.max, 10) : Infinity;
        return Math.max(min, Math.min(max, v));
      };

      if (decr) {
        decr.addEventListener("click", () => {
          input.value = clamp((parseInt(input.value, 10) || 1) - 1);
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }
      if (incr) {
        incr.addEventListener("click", () => {
          input.value = clamp((parseInt(input.value, 10) || 1) + 1);
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }
    }

    // ── Inject FA check icons into description list items ─────────────
    // (FA Kit replaces <i> tags via MutationObserver, so dynamic insert works)
    // Spec tabs (Features / General Specifications) use a plain dash prefix
    // instead — see .pdp-spec-content li::before in _product.scss.
    const checkContainers = document.querySelectorAll(".pdp-description-content");
    checkContainers.forEach(function (container) {
      container.querySelectorAll("li").forEach(function (li) {
        // Idempotency check covers both <i> (pre-FA-render) and <svg>
        // (post-FA-render) — re-runs after MutationObserver shouldn't
        // stack icons.
        if (li.querySelector(":scope > .pdp-check")) return;
        const icon = document.createElement("i");
        icon.className = "fal fa-check pdp-check mr-2";
        li.insertBefore(icon, li.firstChild);
      });
    });

    // (Product Quote modal init lives in common.js so it runs on PLP too.)

    // ── Tab switching (data-bs-target style, no Bootstrap dep) ────────
    const tabLinks = document.querySelectorAll(".tab-link[data-bs-target]");
    tabLinks.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        const parent = link.closest("[role='tablist']");
        if (parent) {
          parent.querySelectorAll(".tab-link").forEach(function (sibling) {
            sibling.classList.remove("active");
            sibling.setAttribute("aria-selected", "false");
          });
        }

        link.classList.add("active");
        link.setAttribute("aria-selected", "true");

        const targetSelector = link.getAttribute("data-bs-target");
        const targetPane = document.querySelector(targetSelector);
        if (targetPane) {
          const container = targetPane.closest(".tab-content");
          if (container) {
            container.querySelectorAll(".tab-pane").forEach(function (pane) {
              pane.classList.remove("show", "active");
            });
          }
          targetPane.classList.add("show", "active");
        }
      });
    });
  },

  finalize() {
    // Fired after common finalize on single product pages
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/productSingle.js